module.exports = __webpack_public_path__ + "static/niegolewskich-img-6-51e61b60f72823541c9f5f4f3beb89f7.jpg";